import './expandable.scss';
import 'details-element-polyfill';
import { expand, collapse } from './expandable-transition';

class Expandable {
	constructor(element, settings) {
		const options =
			(element.dataset.expandableOptions
				? JSON.parse(element.dataset.expandableOptions)
				: null) || {};

		this.options = Object.assign(
			{
				targets: null,
				persist: false
			},
			settings,
			options
		);

		this.element = element;
		this.targets =
			typeof this.options.targets === 'string'
				? document.querySelectorAll(this.options.targets)
				: this.options.targets;

		if (!this.targets.length) {
			return;
		}

		if (this.options.persist && window.localStorage) {
			this.persistanceId = `expandable-${this.options.persist}`;
		}

		this.isExpanded = this.element.getAttribute('aria-expanded') === 'true';

		this.init();
	}

	init() {
		if (this.persistanceId) {
			const initialState = window.localStorage.getItem(this.persistanceId);

			if (initialState) {
				const expandedState = initialState === 'true';

				if (expandedState !== this.isExpanded) {
					this.toggle(expandedState, {
						skipAnimation: true
					});
				}
			}
		}

		this.element.addEventListener('click', () => {
			this.toggle();
		});
	}

	toggle(targetState, options = {}) {
		this.isExpanded = targetState !== undefined ? targetState : !this.isExpanded;

		this.element.setAttribute('aria-expanded', this.isExpanded);

		this.targets.forEach(target => {
			if (this.isExpanded) {
				expand(target, {
					skipAnimation: options.skipAnimation
				});
			} else {
				collapse(target, {
					skipAnimation: options.skipAnimation
				});
			}

			if (this.persistanceId) {
				window.localStorage.setItem(this.persistanceId, this.isExpanded);
			}
		});
	}
}

const elements = document.querySelectorAll('[data-init="expandable-new"]');

elements.forEach(element => {
	new Expandable(element);
});

export { Expandable };
